import { Outlet } from 'react-router-dom'

import { AdminRootPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import companies from 'modules/core/store/collections/companies'

import ActiveHoneypot from 'modules/attendance/components/ActiveAttendance'
import CollectionsBootstrap from 'modules/attendance/lib/TimetrackingCollectionsBootstrap'
import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'

const Container = () => {
  const { employee } = useCurrentSession()
  const { data, loading } = useQuery(AdminRootPageDocument)
  const comanyHasAttendance = companies.current.attributes.has_attendance
  const canSeeAppStore = data?.integrationsBase._policies.seeAppStore.can ?? false
  const canReadAttendance = !!data?.attendance._policies.companyReadAttendance.can

  if (loading) return <Loading />
  if (!comanyHasAttendance && canSeeAppStore) return <ActiveHoneypot />
  if (!comanyHasAttendance || !canReadAttendance || !hasRegularAccessOrNotEmployee(employee))
    return <NotFound />

  return <Outlet />
}

const AdminRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default AdminRootPage
